import React, { useEffect } from "react";
import "./App.css";
import Home from "./Pages/Home";
import Services from "./Pages/Services";
import Plans from "./Pages/Plans";
import Care from "./Pages/Care";
import { useAuth } from "./context/AuthContext.jsx";
import { toast } from "react-toastify";


function App() {
  const { user, authloading } = useAuth();

  useEffect(() => {
    if (!authloading && user === null) {
      toast.error("Some feature is not available for you, please login to access it");
    }
  }, [authloading, user]);

  if (authloading) return 

  return (
    <div>
      <Home />
      <Plans />
      <Services />
      <Care />
    </div>
  );
}

export default App;
